import { createTranslateLoader } from './modules/core/core.module';
const ɵ0 = (createTranslateLoader);
export class AppModule {
}
export { ɵ0 };
